import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { HeroSchedule } from './HeroSchedule';
import { WelcomeMessage } from './WelcomeMessage';
import { CostAndFormat } from './CostAndFormat';
import { AllowedFirearms } from './AllowedFirearms';
import { ImportantRules } from './ImportantRules';
import { RulesetLink } from './RulesetLink';
import { MatchDirector } from './MatchDirector';
import { QuickLinks } from './QuickLinks';
export function SteelChallengePage() {
  return <PageLayout data-id="element-3484">
      <HeaderBanner data-id="element-3485" />
      <HeroSchedule data-id="element-3486" />
      <WelcomeMessage data-id="element-3487" />
      <CostAndFormat data-id="element-3488" />
      <AllowedFirearms data-id="element-3489" />
      <ImportantRules data-id="element-3490" />
      <RulesetLink data-id="element-3491" />
      <MatchDirector data-id="element-3492" />
      <QuickLinks data-id="element-3493" />
    </PageLayout>;
}